import React, { useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";
import FormRender from "../../components/FormRender";
import {  PPT_QUERY_FORM_SETTINGS } from "../../helper";


const PPTQuery = () => {
  const axiosInstance = useAxiosInstance();
  const [formData, setFormData] = useState({ report_id: "" , query:"", org:{}});
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    const API = "assets/ppt_query/"
    if (!formData?.report_id) {
      toast.info("Please provide report id");
      return;
    }
    try {
      setIsDownloading(true);
      const response = await axiosInstance.post(
        API,
        { report_id: Number(formData.report_id),  query: formData.query, org_id: Number(Object.keys(formData.org|| {})?.[0])},
      );
      console.log(response.data)
      toast.success("Fired successfully!");
    } catch (err) {
      console.error("Download error:", err);
      toast.error("Fired failed");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="h-screen overflow-y-auto mr-2">
      <div className="p-4 my-4 border rounded-lg bg-white w-full">
        <p className="text-2xl text-black font-medium mb-4">PPT Query</p>
        <div className="rounded-xl bg-gray-100 p-3">
          <FormRender
            formData={formData}
            formSettings={PPT_QUERY_FORM_SETTINGS}
            setFormData={setFormData}
          />
          <div className="flex items-end mt-4">
            <button
              onClick={handleDownload}
              disabled={isDownloading || !formData?.report_id}
              className="px-4 py-2 h-[42px] disabled:bg-gray-300 bg-black rounded-lg text-white font-semibold"
            >
              {isDownloading ? "Firing..." : "Fire"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PPTQuery;


